import { ActionReducer, ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import * as fromPost from 'src/app/ngrx-store/post/post.reducer';
import * as fromAuth from 'src/app/ngrx-store/auth/auth.reducer';
import * as fromDb from 'src/app/ngrx-store/db/db.reducer';
import * as fromFilter from 'src/app/ngrx-store/filters/filters.reducer';
import * as fromExcelImporter from 'src/app/ngrx-store/excelImport/excelImport.reducer';
import * as fromRuleEngine from 'src/app/ngrx-store/rule-engineV2/rule-engine.reducer';
import { environment } from 'src/environments/environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

export interface AppState {
  router: RouterReducerState<any>;
  posts: fromPost.State;
  auth: fromAuth.State;
  dbs: fromDb.State;
  filters: fromFilter.State;
  UIExcelColumns: any;
  RuleEngine:any;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  posts: fromPost.reducer,
  auth: fromAuth.AuthReducer,
  dbs: fromDb.reducer,
  filters: fromFilter.reducer,
  UIExcelColumns: fromExcelImporter.excelImportReducer,
  RuleEngine:fromRuleEngine.ruleEngineReducer
};

export const authState = createFeatureSelector<AppState>('auth');
export const dbState = createFeatureSelector<AppState>('dbs');
export const filterState = createFeatureSelector<AppState>('filters');
export const UIExcelColumnsState = createFeatureSelector<AppState>('UIExcelColumns');
export const ruleEngineState = createFeatureSelector<AppState>('RuleEngine');

export function logger(reducer: ActionReducer<AppState>): ActionReducer<any, any> {
  return (state: AppState, action: any): AppState => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
